/**
 * Application Entry Point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { RootErrorBoundary } from './components/Common/RootErrorBoundary';
import { ensureTokenizer } from './utils/tokenBudget';
import './index.css';

// Warm the exact tokenizer in the background so the first chat turn doesn't
// pay its load latency (and budgeting is exact from turn one). Fire-and-forget;
// getChatCompletion also awaits it as a safety net.
void ensureTokenizer();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  </React.StrictMode>
);
